import { qs } from './utils'

export const root = qs('.curves-root')
